import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 128 128",
  style: {"enable-background":"new 0 0 128 128"},
  "xml:space": "preserve"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      style: {"fill":"#191919"},
      d: "M118.448 123.224H9.552c-5.267 0-9.552-4.285-9.552-9.552V14.328c0-5.267 4.285-9.552 9.552-9.552h108.896c5.267 0 9.552 4.285 9.552 9.552v99.343c0 5.267-4.285 9.553-9.552 9.553zM9.552 12.418c-1.054 0-1.91.857-1.91 1.91v99.343c0 1.053.856 1.91 1.91 1.91h108.896c1.054 0 1.91-.857 1.91-1.91V14.328c0-1.053-.856-1.91-1.91-1.91H9.552zM100.299 64 41.075 31.284v65.433L100.299 64z"
    }, null, -1)
  ]))]))
}
export default { render };